import { logger } from './logger';
// TODO: Investigate removing this, as the client shouldn't request the API multiple times
export const createRequestCache = ()=>{
    const requestCache = new Map();
    return (request, key)=>{
        const cachedPromise = requestCache.get(key);
        if (cachedPromise) {
            logger.trace(`Returning cached promise for key '${key}'`);
            return cachedPromise;
        }
        const requestPromise = request();
        requestCache.set(key, requestPromise);
        const removeRequestFromCache = ()=>requestCache.delete(key)
        ;
        requestPromise.then(removeRequestFromCache, removeRequestFromCache);
        return requestPromise;
    };
};
export const getKeyForRequest = (url, requestConfig)=>{
    return JSON.stringify([
        url,
        requestConfig == null ? void 0 : requestConfig.urlParams,
        requestConfig == null ? void 0 : requestConfig.queryParams
    ]);
};

//# sourceMappingURL=request-cache.js.map